import type { UserResult, UserPayload } from '@alexanderathoodly/data-models'
import type { AuthQueryFactory, AuthMutationFactory } from './useauthquery'
import { apiClient } from '~/utils/requests'

export const currentUserDataQuery: AuthQueryFactory<[], UserResult> = () => {
	return {
		queryKey: ['currentUserData'],
		queryFn: async ({ jwtToken }) => {
			return await apiClient.getCurrentUser(jwtToken)
		},
	}
}

type UserUpdateData = Partial<UserPayload>

export const updateUserDataMutation: AuthMutationFactory<
	UserResult,
	UserUpdateData
> = ({ queryClient }) => {
	return {
		mutationFn: async ({ jwtToken }, data) => {
			return await apiClient.partialUpdateCurrentUser(data, jwtToken)
		},
		onSuccess: (res) => {
			void queryClient.setQueryData(['currentUserData'], res)
		},
	}
}

type AccountUsersQueryKey = ['users', { companyId: string }]

export const usersInCompanyQuery: AuthQueryFactory<
	[companyId: string],
	UserResult[],
	UserResult[],
	AccountUsersQueryKey
> = (_, companyId) => {
	return {
		queryKey: ['users', { companyId }],
		queryFn: async ({ jwtToken, queryKey }) => {
			const companyId = queryKey[1].companyId
			return await apiClient.getUsers({ company: companyId }, jwtToken)
		},
		enabled: !!companyId,
	}
}

export const createUserMutation: AuthMutationFactory<
	UserResult,
	UserPayload
> = ({ queryClient }) => {
	return {
		mutationFn: async ({ jwtToken }, data) => {
			return await apiClient.createUser(data, jwtToken)
		},
		onSuccess: (res) => {
			const companyId = res.company
			void queryClient.invalidateQueries(['users', { companyId: companyId }])
		},
	}
}
